
scittle.javelin.init();